module.exports = __webpack_public_path__ + "img/dashboard.5e09ece6.svg";